export default "__VITE_ASSET__CsMJCYD7__"